import React from "react"
import {
  footer,
  footerLinks,
  footerSocial,
  goToHead,
  footerBottom,
  footerContent,
} from "./footer.module.scss"
import Icon from "../../Icon/icon"
import SocialMedias from "../../SocialMedias/social-medias"
import InscriptionNewsletter from "../../InscriptionNewsletter/inscriptionNewsletter"
import { StyledFooter, GoToHead, FooterBottom } from "./footer-styled"
import TransitionFade from "../../transition-fade"
import { useFooter } from "./footer-query"
import { useBuildData } from "gatsby-theme-blank/src/hooks/use-build-data"
import { goToTop } from "react-scrollable-anchor"

//-----------------------Footer component---------------------------//

const Footer = () => {
  const data = useFooter()
  const accessibility = useBuildData().site_settings.accessibility
  const footerMenuData = data.graphqlData?.menuByName?.links
  return (
    <>
      <StyledFooter className={footer} role="contentinfo" id="footer">
        <div className={footerContent}>
          {footerMenuData?.length > 0 && (
            <div className={footerLinks}>
              <ul>
                {footerMenuData.map((link) => (
                  <li key={link.label}>
                    <TransitionFade link={link.url.path}>
                      {link.label}
                    </TransitionFade>
                  </li>
                ))}
              </ul>
            </div>
          )}
          <InscriptionNewsletter hasBorderRight={true} />
          <div className={footerSocial}>
            <SocialMedias />
          </div>
          <GoToHead
            aria-label="Retour en haut de page"
            onClick={() => goToTop()}
            className={goToHead}
            onKeyDown={(event) => {
              if (event.key === "Enter") {
                goToTop()
              }
            }}
            role="button"
            tabIndex="0"
          >
            <Icon size={65} icon="circle-up"></Icon>
          </GoToHead>
        </div>
        <FooterBottom className={footerBottom}>
          <li>
            <TransitionFade link="/plan-site">Plan du site</TransitionFade>
          </li>
          <li>
            <a href="/rgpd" target="_blank">
              Règlement général sur la protection des données
            </a>
          </li>
          <li>
            <TransitionFade link="/mentions-legales">
              Mentions Légales
            </TransitionFade>
          </li>
          <li>
            <TransitionFade link="/mentions-legales#accessibilite">
              {accessibility ?? "Accessibilité"}
            </TransitionFade>
          </li>
        </FooterBottom>
      </StyledFooter>
    </>
  )
}

//-----------------------Footer component---------------------------//

export default Footer
